// extracted by mini-css-extract-plugin
export var active = "_vp-1";
export var circle = "_vp-0";
export var completed = "_vp-2";
export var connector = "_vp-4";
export var connectorCompleted = "_vp-7";
export var connectorSpacer = "_vp-5";
export var iconStrokeOverride = "_vp-8";
export var labelContainer = "_vp-6";
export var pending = "_vp-3";